import _ from 'lodash';
import * as React from 'react';

import { Activity } from './interfaces';
import { FLAG_FILTERS } from './shared';

import { flagOptions } from '../../../../../../constants/flagOptions';
import { Checkbox, DISABLED, } from '../../../../../Shared/index';

interface FlagFilterRowProps {
  flagFilters: string[],
  flag: string,
  handleFlagFilterChange: (flagFilters: string[]) => void,
  filteredActivities: Activity[]
}

interface FlagFiltersProps {
  activities: Activity[],
  filterActivities: (ignoredKey?: string) => Activity[]
  flagFilters: string[],
  handleFlagFilterChange: (flagFilters: string[]) => void,
}

const FlagFilterRow = ({ flagFilters, flag, handleFlagFilterChange, filteredActivities, }: FlagFilterRowProps) => {
  const activityCount = filteredActivities.filter(act => act.flags.includes(flag)).length
  const selected = flagFilters.includes(flag)
  const disabled = activityCount === 0

  function toggleCheckbox() {
    if (selected) {
      uncheckIndividualFilter()
    } else {
      checkIndividualFilter()
    }
  }

  function checkIndividualFilter() {
    const newFlagFilters = Array.from(new Set(flagFilters.concat([flag])))
    handleFlagFilterChange(newFlagFilters)
  }

  function uncheckIndividualFilter() {
    const newFlagFilters = flagFilters.filter(k => k !== flag)
    handleFlagFilterChange(newFlagFilters)
  }

  return (
    <div className="individual-row filter-row" key={flag}>
      <div>
        <Checkbox
          ariaLabel={`Filter by ${flag}`}
          onClick={toggleCheckbox}
          selected={selected}
          state={disabled ? DISABLED : null}
        />
        <span id={flag}>{_.capitalize(flag)}</span>
      </div>
      <span>({activityCount})</span>
    </div>
  )
}

const FlagFilters = ({ activities, filterActivities, flagFilters, handleFlagFilterChange, }: FlagFiltersProps) => {
  function clearAllFlagFilters() { handleFlagFilterChange([]) }

  const filteredActivities = filterActivities(FLAG_FILTERS)

  // TODO: flag display
  const flagRows = flagOptions.map(ac =>
    (<FlagFilterRow
      filteredActivities={filteredActivities}
      flag={ac.value}
      flagFilters={flagFilters}
      handleFlagFilterChange={handleFlagFilterChange}
      key={ac.value}
    />)
  )
  const clearButton = flagFilters.length ? <button className="interactive-wrapper clear-filter focus-on-light" onClick={clearAllFlagFilters} type="button">Clear</button> : <span />

  return (
    <section aria-labelledby="flagsTitle" className="filter-section flag-filter-section">
      <div className="name-and-clear-wrapper">
        <h2 id="flagsTitle">Flags</h2>
        {clearButton}
      </div>
      {flagRows}
    </section>
  )
}

export default FlagFilters
